import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    Optional,
    Renderer2,
    Self,
    ViewChild,
} from "@angular/core";
import { NgControl } from "@angular/forms";
import * as momentImport from "moment-timezone";
import { Moment } from "moment-timezone";

import { SpsFormControlComponent } from "../forms/sps-form-control.abstract.component";

const moment = momentImport; // this is needed for rollup when you're going to call moment() as a function

/** This particular component doesn't utilize the TIME_FORMAT
 *  provider because its design is based upon a specific format:
 *  12-hour time + AM/PM. */
@Component({
    selector: "sps-time-input",
    templateUrl: "./sps-time-input.component.html",
    styleUrls: ["./sps-time-input.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsTimeInputComponent extends SpsFormControlComponent<Moment> {
    static readonly displayName = "sps-time-input";
    static readonly props = {};

    amPmOptions = ["AM", "PM"];
    amPm = "AM";

    private clearable = true;

    private _text = "";
    get text() {
        return this._text;
    }
    set text(value: string) {
        this._text = value;
        this.updateValueFromInputs();
    }

    get value(): Moment {
        return this.model;
    }
    set value(newValue: Moment) {
        this.model = newValue;
    }

    @HostBinding("class.sps-time-input--clearable") get isClearable() {
        return this.clearable && this.value && !this.isDisabled;
    }

    @ViewChild("textInput", { static: false }) inputElement: ElementRef;

    constructor(
        protected _changeDetector: ChangeDetectorRef,
        _el: ElementRef,
        _renderer: Renderer2,
        @Self()
        @Optional()
        _ngControl: NgControl
    ) {
        super(_el, _renderer, _ngControl);
    }

    updateValueFromInputs() {
        if (this.text.trim()) {
            const split = this.text.split(":");
            this.value = (this.value ? this.value.clone() : moment()).set({
                hour: +split[0] + (this.amPm === "AM" ? 0 : 12),
                minute: +split[1]
            });
        } else {
            this.value = undefined;
        }
        this._propagateChange(this.value);
    }

    updateInputsFromValue() {
        if (this.value) {
            this._text = this.value.format("h:mm");
            this.amPm = this.value.hour() < 12 ? "AM" : "PM";
        } else {
            this._text = "";
        }
    }

    writeValue(value: Moment) {
        super.writeValue(value);
        this.updateInputsFromValue();
    }

    disableClearing() {
        this.clearable = false;
        this._changeDetector.markForCheck();
    }
}
